module.exports = __webpack_public_path__ + "img/agent-avatar.aacf3d08.png";